import { ComponentStatus } from "@type/status";

export const helperTextMap = {
    "": undefined,
    "error": "danger",
    "default": "secondary",
};

export const antdStatusMap = {
    [ComponentStatus.ERROR]: "error",
    [ComponentStatus.SUCCESS]: "",
    [ComponentStatus.DEFAULT]: "",
} as const;
